import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/services';
import { DeductionType } from '@models/payroll/deduction-type.model';

@Injectable()
export class DeductionTypeResolver {
    constructor(
        protected auth: AuthService,
        protected router: Router
    ) {}

    async resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<DeductionType[]> {
        const [deductionTypes] = await DeductionType.get();

        return deductionTypes;
    }
}
